import { Box, useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { userDatabaseUpdateRequest } from '../../../canopy-ui-components/api/clientList';
import CanopyButton from '../../../canopy-ui-components/components/CanopyButton/CanopyButton';
import * as ga from '../../../canopy-ui-components/google-analytics';
import { useCurrentColors } from '../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';

const UpdateDBAction = ({
    globalProps,
    selectedFlatRows,
    refreshData,
    layoutState,
}: any) => {
    const currentColors = useCurrentColors();
    const { t } = globalProps;
    const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const toast = useToast();
    const getSelectedRows = (selectedFlatRows: any[]) => {
        let selectedRows: any = [];
        if (Array.isArray(selectedFlatRows)) {
            selectedFlatRows
                ?.filter(({ original }) => original.isChild === false)
                .forEach(({ original, originalSubRows }: any) => {
                    selectedRows = selectedRows.concat([original]);
                });
        }
        return selectedRows;
    };
    const showToast = ({ title, backgroundColor }: Record<string, any>) => {
        toast({
            position: 'bottom-right',
            duration: 2000,
            render: () => (
                <Box
                    color="white"
                    p={3}
                    bg={backgroundColor}>
                    {title}
                </Box>
            ),
        });
    };
    const handleUpdateUsersDB = async () => {
        const userIds = selectedUsers.map((user: any) => user.id);
        const parentUserId: any = userIds.toString();
        ga.event({
            action: `Client List > Update DB`,
        });
        setIsLoading(true);
        try {
            let response: any = await userDatabaseUpdateRequest({
                parent_user_ids: parentUserId,
            });
            if (response.error) {
                showToast({
                    title: response.error,
                    backgroundColor: currentColors.errorText,
                });
            } else if (response.status === 'queued') {
                showToast({
                    title: t('user-update-db-queued'),
                    backgroundColor: 'green.500',
                });
            }
        } catch (err: any) {
            showToast({
                title:
                    t(err?.response?.data?.error) ||
                    err?.response?.data?.message,
                backgroundColor: currentColors.errorText,
            });
        } finally {
            setTimeout(() => {
                refreshData();
            }, 2000);
            setIsLoading(false);
        }
    };
    useEffect(() => {
        setSelectedUsers(getSelectedRows(selectedFlatRows));
    }, [selectedFlatRows]);

    if (selectedFlatRows?.length) {
        return (
            <CanopyButton
                fontSize="sm"
                fontWeight="bold"
                variant="solid"
                isLoading={isLoading}
                onClick={handleUpdateUsersDB}
                size="sm">
                {globalProps.t('ui.mm.tooltip.update-db', {
                    count: selectedUsers?.length,
                })}
            </CanopyButton>
        );
    }
    return null;
};

export default UpdateDBAction;
